import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

type B2CModeState = {
  dimension: GameDimension;
  changeDimension: (dimension: GameDimension) => void;
  toggleDimension: () => void;
};

export const useGameDimensionStore = create<B2CModeState>()(
  persist(
    immer((set) => ({
      dimension: '3D' as const,
      changeDimension: (dimension) => {
        set((state) => {
          state.dimension = dimension;
        });
      },
      toggleDimension: () => {
        set((state) => {
          state.dimension = state.dimension === '2D' ? '3D' : '2D';
        });
      },
    })),
    {
      name: 'coinraces-b2c-game-dimension-storage',
      partialize: (state) => ({ mode: state.dimension }),
    }
  )
);

export type GameDimension = '2D' | '3D';
